import Home from '../../../../assets/images/sidebarIcons/console.svg';
import Messages from '../../../../assets/images/sidebarIcons/message.svg';
import Import from '../../../../assets/images/sidebarIcons/import.svg';
import Queue from '../../../../assets/images/sidebarIcons/queue.svg';
import Contacts from '../../../../assets/images/sidebarIcons/contacts.svg';
import Settings from '../../../../assets/images/sidebarIcons/settings.svg';

import RoutesPaths from '../../../../RoutesPaths';

const MenuList = [
  { title: 'Pulpit', image: Home, url: RoutesPaths.Home.path },
  { title: 'Wyślij wiadomość', image: Messages, url: RoutesPaths.Messages.path },
  { title: 'Import wiadomości', image: Import, url: RoutesPaths.Import.path },
  { title: 'Kolejka wiadomości', image: Queue, url: RoutesPaths.MessagesQueue.path },
  { title: 'Kontakty', image: Contacts, url: RoutesPaths.Contact.path },
  { title: 'Integracje', image: Settings, url: RoutesPaths.Settings.path },
];

export default MenuList;
